export default "{\n    \"heading\": \"Construction\",\n    \"headings\": {\n        \"newProject\": \"Nouveau projet\"\n    }\n}\n"